// Backend address for the website and the CRM.
// The backend runs on Cloudflare at https://api.vktours.com (workers/api). REACT_APP_BACKEND_URL, when set
// at build time, overrides this; on a developer machine the local backend on port 8001 is used.
export const PRODUCTION_API_URL = 'https://api.vktours.com';

const getBackendURL = () => {
  if (process.env.REACT_APP_BACKEND_URL) return process.env.REACT_APP_BACKEND_URL;
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:8001';
  }
  // vktours.com, www, crm.vktours.com, Cloudflare Pages previews and the prerender step
  return PRODUCTION_API_URL;
};

export const BACKEND_URL = getBackendURL();
export default BACKEND_URL;
